import api from './index.js'

export const fetchNotices = async (
  currentPage,
  pageSize,
  params,
  sortColumn,
  sortDirection
) => {
  try {
    const queryParams = new URLSearchParams(params).toString() // Convert params object to query string
    const response = await api.get(
      `/admin/notice?pageNumber=${currentPage}&pageSize=${pageSize}&sortColumn=${sortColumn}&sortDirection=${sortDirection}&${queryParams}`
    )

    if (response.status === 200) {
      const data = response.data
      // Handle successful response
      // ...
      return data
    } else {
      throw new Error('Failed to fetch notices')
    }
  } catch (error) {
    // Handle error
    // ...
    throw new Error('Failed to fetch notices')
  }
}
export const fetchNotice = async id => {
  try {
    const response = await api.get(`/admin/notice/${id}`)

    if (response.status === 200) {
      const data = response.data
      // Handle successful response
      // ...
      return data
    } else {
      throw new Error('Failed to fetch notice')
    }
  } catch (error) {
    // Handle error
    // ...
    throw new Error('Failed to fetch notice')
  }
}

export const updateNotice = async (id, noticeData) => {
  try {
    const response = await api.put(`/admin/notice/${id}`, noticeData)

    if (response.status === 200) {
      const data = response.data
      // Handle successful response
      // ...
      return data
    } else {
      throw new Error('Failed to update notice')
    }
  } catch (error) {
    // Handle error
    // ...
    throw new Error('Failed to update notice')
  }
}

export const createNotice = async noticeData => {
  try {
    const response = await api.post('/admin/notice', noticeData)

    if (response.status === 200) {
      const data = response.data
      // Handle successful response
      // ...
      return data
    } else {
      throw new Error('Failed to create notice')
    }
  } catch (error) {
    // Handle error
    // ...
    throw new Error('Failed to create notice')
  }
}

export const deleteNotice = async id => {
  try {
    const response = await api.delete(`/admin/notice/${id}`)

    if (response.status === 200) {
      const data = response.data
      // Handle successful response
      // ...
      return data
    } else {
      throw new Error('Failed to delete notice')
    }
  } catch (error) {
    // Handle error
    // ...
    throw new Error('Failed to delete notice')
  }
}
